import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { RootState } from 'rootReducer';
import { useImageOnLoad } from 'modules/shared/hooks';
import { routes } from '../../entities/Roles/constants';

export const Login: React.FC = () => {
  const auth = useSelector((state: RootState) => state.authModuleReducer.authReducer);
  const name = auth.role?.name;
  const { handleImageOnLoad, css } = useImageOnLoad();

  return (
    <div className="w-100 d-flex align-items-center justify-content-center vh-100">
      <Card border="danger" className="col-md-3">
        <Card.Text className="p-3 m-0">
          <Card.Img
            src="https://www.scm.com.cy/media/cache/social_thumb_big/uploads/images/RA1_O9H4IMQUzIBvHxYu-A.png"
            alt="МЕТІНТВЕСТ"
            onLoad={handleImageOnLoad}
            style={{ ...css.fullSize }}
          />
        </Card.Text>

        <Card.Body className="pt-0 text-center">
          <h4>
            Електронна черга v{process.env.REACT_APP_VERSION}/{process.env.REACT_APP_VERSION_DATA}
          </h4>

          <Card.Text className="py-3">
            {auth.role ? (
              <span className="font-weight-bold">
                Вхід не виконано.
                {auth.account?.username} ({auth.role?.title})
              </span>
            ) : (
              <span className="font-weight-bold">Вхід не виконано.</span>
            )}
          </Card.Text>

          <Card.Text>
            {/* @ts-ignore */}
            <Link to={name ? `${routes[name]}` : '/auth'}>
              <Button variant="light" className="w-100">
                <h4 className="mb-1">Вхід</h4>
              </Button>
            </Link>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};
